// extracted by mini-css-extract-plugin
export var addButton = "_g4-0";
export var border = "_g4-8";
export var check = "_g4-h";
export var danger = "_g4-6";
export var dropdownContainer = "_g4-1";
export var editModalBody = "_g4-j";
export var footerContainer = "_g4-i";
export var fullWidth = "_g4-a";
export var hide = "_g4-9";
export var icon = "_g4-3";
export var input = "_g4-7";
export var inputFlex = "_g4-b";
export var inputWrapper = "_g4-c";
export var manualFocus = "_g4-5";
export var optionButton = "_g4-4";
export var pillWrapper = "_g4-e";
export var pointer = "_g4-2";
export var showOverflow = "_g4-f";
export var tagsFlex = "_g4-d";
export var xButton = "_g4-g";